<template>
  <step-wizard v-model="step" :can-go-back="!anySent && !busy">
    <!-- С чем работаем: видно и когда дерево слева свёрнуто -->
    <template #header>
      <div class="entry-subject">
        <div v-if="unitPath.length" class="entry-subject__row">
          <span class="entry-subject__label">Филиал / Подразделение / Участок</span>
          <span class="entry-subject__value" :title="unitPath.join(' → ')">
            {{ unitPath.join(" → ") }}
          </span>
        </div>
        <div class="entry-subject__row">
          <span class="entry-subject__label">Отход</span>
          <span class="entry-subject__value" :title="wasteLabel">
            {{ wasteLabel }}
          </span>
        </div>
      </div>
    </template>

    <wizard-step name="mode" title="Выбор типа движения">
      <mode-step></mode-step>
    </wizard-step>

    <wizard-step name="entry" :title="entryTitle">
      <entry-step @saved="$emit('saved')" @cancel="$emit('cancel')"></entry-step>
    </wizard-step>

    <!-- Поступление: этап полей появляется, только когда нажали кнопку дальнейшего действия -->
    <wizard-step v-if="isIncoming && action" name="details" :title="detailsTitle">
      <details-step @saved="$emit('saved')" @cancel="$emit('cancel')"></details-step>
    </wizard-step>
  </step-wizard>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import StepWizard from "@/components/ecologist/dataEntryNew/stepWizard";
import WizardStep from "@/components/ecologist/dataEntryNew/wizardStep";
import ModeStep from "@/components/ecologist/dataEntryNew/modeStep";
import EntryStep from "@/components/ecologist/dataEntryNew/entryStep";
import DetailsStep from "@/components/ecologist/dataEntryNew/detailsStep";

/*
  Внесение данных по отходу: режим → даты с количеством (у расхода - и с полями режима)
  → у поступления поля дальнейшего действия. Состояние - в модуле стора wasteEntry
*/
export default {
  name: "wasteEntry",
  components: { StepWizard, WizardStep, ModeStep, EntryStep, DetailsStep },
  props: {
    // Узел отхода из дерева: techProcessHasWasteId, organizationWasteId, unitId, name
    waste: { type: Object, required: true },
    // Названия подразделений над отходом, от предприятия вниз
    unitPath: { type: Array, default: () => [] },
  },

  computed: {
    ...mapState("wasteEntry", ["action", "busy"]),
    ...mapGetters("wasteEntry", [
      "isIncoming",
      "anySent",
      "entryTitle",
      "detailsTitle",
      // Есть что терять при переключении на другой элемент дерева
      "isDirty",
    ]),
    step: {
      get() {
        return this.$store.state.wasteEntry.step;
      },
      set(step) {
        this.$store.commit("wasteEntry/setStep", step);
      },
    },
    firstDate() {
      return this.$store.state.wasteEntry.dates[0];
    },
    wasteLabel() {
      return [this.waste.code, this.waste.wasteName || this.waste.name]
        .filter(Boolean)
        .join(" ");
    },
  },

  watch: {
    // Контрагенты передачи - с договором, действующим на первую дату. Даты меняются на обоих экранах
    firstDate() {
      this.$store
        .dispatch("wasteEntry/reloadOptions")
        .catch(() => this.$message.error("Не удалось загрузить справочники"));
    },
  },

  created() {
    this.$store.dispatch("wasteEntry/start", this.waste);
  },

  async mounted() {
    try {
      await this.$store.dispatch("wasteEntry/loadPage");
    } catch (error) {
      this.$message.error("Не удалось загрузить данные отхода");
    }
  },
};
</script>

<style scoped>
/* Подразделение и отход - в одну строку, каждый обрезается многоточием, если не влезает */
.entry-subject {
  flex-shrink: 0;
  display: flex;
  gap: 32px;
  margin-bottom: 12px;
  padding: 8px 12px;
  border: 1.5px solid #dcdfe6;
  border-radius: 8px;
  background: #fff;
  font-size: 13px;
  line-height: 20px;
}
.entry-subject__row {
  display: flex;
  gap: 6px;
  min-width: 0;
}
.entry-subject__label {
  flex-shrink: 0;
  color: #909399;
}
.entry-subject__label::after {
  content: ":";
}
/* Длинный путь обрезается многоточием, полностью - в подсказке */
.entry-subject__value {
  min-width: 0;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
